<template>
    <td-dialog
        :title="$t(title)"
        @cancel="trusteeshipDialogClose"
        :before-close="trusteeshipDialogClose"
        :visible.sync="dialogTrusteeshipVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="310px"
        top="18vh"
    >
        <el-form :model="formTrusteeship" :label-width="formLabelWidth" ref="formTrusteeship" :rules="rules">
            <el-form-item :label="$t('pgCommon.TABLE_NAME')" prop="sTableName">
                <td-input v-model="formTrusteeship.sTableName"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.TABLE_NOTES')" prop="sTableNotes">
                <td-input v-model="formTrusteeship.sTableNotes"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.TABLE_DICTIONARY')" prop="iDictionary">
                <td-radio v-model="formTrusteeship.iDictionary" :options="optionsDictionary"></td-radio>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.BELONG_DATABASE')">
                <td-input v-model="formTrusteeship.sDatabaseName" :disabled="true"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.KEY_FIELD')" prop="dbType">
                <td-select v-model="formTrusteeship.sKeyField" :placeholder="$t('pgCommon.PLEASE_SELECT')" :options="keyFieldList" keys="sColumnName" text="sColumnNotes"> </td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.VALUE_FIELD')" prop="dbType">
                <td-select v-model="formTrusteeship.sValueField" :placeholder="$t('pgCommon.PLEASE_SELECT')" :options="valueFieldList" keys="sColumnName" text="sColumnNotes"> </td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DESC_FIELD')" prop="dbType">
                <td-select v-model="formTrusteeship.sDescField" :placeholder="$t('pgCommon.PLEASE_SELECT')" :options="descFieldList" keys="sColumnName" text="sColumnNotes"> </td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DESCRIPTION')" prop="sDescription">
                <td-input type="textarea" :rows="2" v-model="formTrusteeship.sDescription" maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formTrusteeship')">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dlgTrusteeshipApi from './../assets/api.js';
export default {
    props: ['title', 'dialogTrusteeshipVisible', 'columnList', 'editItem', 'isAddData'],
    created() {
        this.keyFieldList = window.vue.$util.clone(this.columnList);
        this.valueFieldList = window.vue.$util.clone(this.columnList);
        this.descFieldList = window.vue.$util.clone(this.columnList);
        // 为编辑状态则进行初始化数据
        this.editItemNew = this.editItem;
        this.initEditData();
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formTrusteeship: {
                sTableName: '',
                sTableNotes: '',
                iDictionary: 0,
                sDatabaseId: '',
                sDatabaseName: '',
                sKeyField: '',
                sValueField: '',
                sDescField: '',
                sDescription: ''
            },
            // 是否字典表
            optionsDictionary: [
                {
                    value: 0,
                    label: this.$t('pgCommon.NOT')
                },
                {
                    value: 1,
                    label: this.$t('pgCommon.YES')
                }
            ],
            keyFieldList: [],
            valueFieldList: [],
            descFieldList: [],
            editItemNew: {},
            formLabelWidth: '70px',
            // 对表单进行数据验证
            rules: {
                sTableName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sTableNotes: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formTrusteeship.sTableName = this.editItemNew.sTableName;
            this.formTrusteeship.sTableNotes = this.editItemNew.sTableNotes;
            this.formTrusteeship.iDictionary = this.editItemNew.iDictionary;
            this.formTrusteeship.sDatabaseName = this.editItemNew.sDatabaseName;
            this.formTrusteeship.sDescription = this.editItemNew.sDescription;
            this.formTrusteeship.sKeyField = this.editItemNew.sKeyField;
            this.formTrusteeship.sValueField = this.editItemNew.sValueField;
            this.formTrusteeship.sDescField = this.editItemNew.sDescField;
        },

        // 提交数据
        submitForm(formTrusteeship) {
            this.$refs[formTrusteeship].validate(valid => {
                if (valid) {
                    let content = {
                        sId: this.editItemNew.sId,
                        sTableName: this.formTrusteeship.sTableName,
                        sTableNotes: this.formTrusteeship.sTableNotes,
                        iDictionary: this.formTrusteeship.iDictionary === '' ? '0' : this.formTrusteeship.iDictionary,
                        sKeyField: this.formTrusteeship.sKeyField,
                        sValueField: this.formTrusteeship.sValueField,
                        sDescField: this.formTrusteeship.sDescField,
                        sDescription: this.formTrusteeship.sDescription
                    };
                    dlgTrusteeshipApi.updateTrusteeship(JSON.stringify(content), response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('dlgTrusteeshipApi.updateTrusteeship', response);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                        this.trusteeshipDialogClose();
                        this.$emit('edtTbOnSuccess', content);
                    });
                }
            });
        },

        // 取消
        cancel() {
            this.trusteeshipDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        trusteeshipDialogClose() {
            this.$emit('trusteeshipDialogClose');
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
